import useTimeZoneClock from "hooks/useTimeZoneClock";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import React, { useEffect } from "react";
import { cdn } from "constants/common";

const ViewTable = React.memo(({ item }) => {
  const cost_table = React.useMemo(() => {
    return item?.cost_table ? JSON.parse(item?.cost_table) : [];
  }, [item?.cost_table]);

  // const timeZone = useTimeZoneClock(item?.datetime);
  // const formattedDate = moment(timeZone).format('MMMM DD YYYY');
  // const formattedTime = moment(timeZone).format('hh:mm A');

  const formattedDate = moment(item?.created_at).format("MMM D, YYYY h:mm A");

  // console.log("quotation item", item);

  const InfoRow = ({ label, value, toLowerCase = "" }) => (
    <div className="row_detail_tab">
      <div className="label_view">
        <strong>{label}</strong>
      </div>
      <div className={`detail_view ${toLowerCase}`}>{value || "N/A"}</div>
    </div>
  );
  const rowDash1Style = {
    display: "flex",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const rowDash2Style = {
    display: "block",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const marginTopZero = {
    marginTop: 0,
  };
  return (
    <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
      <div className="row_dash_1" style={rowDash1Style}>
        <div className="card_table profile-section" style={marginTopZero}>
          <h2>Quotation Details</h2>

          <div className="Table_data_show Table_data_show1 pt-0">
            <table class="bg-primary-secondary table">
              <tbody>
                {/* <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Translation Id: </td>
                                    <td class="bg-primary-secondary">{item?.translation_id}</td>
                                </tr> */}
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Version:{" "}
                  </td>
                  <td class="bg-primary-secondary">{item?.version}</td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Download Quotation:
                  </td>
                  <td class="bg-primary-secondary">
                    <a
                      href={cdn + item?.pdf_path}
                      download={true}
                      target="_blank"
                    >
                      Quote {item?.version || "N/A"}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Status:
                  </td>
                  {item?.approved == 1 && (
                    <td class="bg-primary-secondary">Approved</td>
                  )}
                  {item?.rejected == 1 && (
                    <td class="bg-primary-secondary">Rejected</td>
                  )}
                  {item?.rejected == 0 && item?.approved == 0 && (
                    <td class="bg-primary-secondary">Pending</td>
                  )}
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Notes:
                  </td>
                  <td class="bg-primary-secondary">{item?.notes}</td>
                </tr>

                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Created by:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.created_by?.name || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Created at:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.created_at &&
                      moment(item?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                        "MMM D, YYYY HH:mm:ss"
                      )}
                  </td>
                </tr>
                {item?.rejected == 1 && (
                  <>
                    <tr>
                      <td class="bg-primary-secondary" style={{ width: "40%" }}>
                        Rejectied By:
                      </td>
                      <td class="bg-primary-secondary">
                        {item?.rejected_by?.name || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary-secondary" style={{ width: "40%" }}>
                        Rejection Reason:
                      </td>
                      <td class="bg-primary-secondary">
                        {item?.rejection_reason || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary-secondary" style={{ width: "40%" }}>
                        Rejected At:
                      </td>
                      <td class="bg-primary-secondary">
                        {moment(item?.rejected_at).format(
                          "MMM D, YYYY HH:mm:ss"
                        ) || "N/A"}
                      </td>
                    </tr>
                  </>
                )}
                {item?.approved == 1 && (
                  <>
                    <tr>
                      <td class="bg-primary-secondary" style={{ width: "40%" }}>
                        Approved By:
                      </td>
                      <td class="bg-primary-secondary">
                        {item?.approved_by?.name || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary-secondary" style={{ width: "40%" }}>
                        Approved At:
                      </td>
                      <td class="bg-primary-secondary">
                        {item?.approved_at &&
                          moment(item?.approved_at).format(
                            "MMM D, YYYY HH:mm:ss"
                          )}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>

          <div className="row_dash_1 profile-section" style={rowDash2Style}>
            <h2>Cost Table</h2>

            <div className="Table_data_show Table_data_show1 pt-0 ">
              {/* {cost_table?.map((ct) => {
                                return (
                                    
                                    <table class="bg-primary-secondary table">
                                        <tbody>
                                            <tr>

                                                <td class="bg-primary-secondary">Rate: </td>
                                                <td class="bg-primary-secondary">{ct?.rate || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <td class="bg-primary-secondary">Total:</td>
                                                <td class="bg-primary-secondary">{ct.total}</td>
                                            </tr>
                                            <tr>

                                                <td class="bg-primary-secondary">File name: </td>
                                                <td class="bg-primary-secondary">{ct?.file_name || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <td class="bg-primary-secondary">Sub Total:</td>
                                                <td class="bg-primary-secondary">{ct.sub_total}</td>
                                            </tr>
                                            <tr>

                                                <td class="bg-primary-secondary">Formatting: </td>
                                                <td class="bg-primary-secondary">{ct?.formatting || 'N/A'}</td>
                                            </tr>
                                            <tr>
                                                <td class="bg-primary-secondary">Word Count:</td>
                                                <td class="bg-primary-secondary">{ct.word_count}</td>
                                            </tr>
                                            <tr>
                                                <td class="bg-primary-secondary">Target Language:</td>
                                                <td class="bg-primary-secondary">{ct.target_language || "N/A"}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )
                            })} */}
              <CostTable list={cost_table} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const CostTable = ({ list }) => {
  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">
          <tr>
            <th className="col-3">Rate</th>
            <th className="col-2">Total</th>
            <th className="col-3">Sub Total</th>
            <th className="col-2">Formatting</th>
            <th className="col-2">Word Count</th>
            <th className="col-2">Target Language</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(list) &&
            list.map((item, index) => (
              <tr key={index}>
                <td className="col-2">
                  {item?.rate !== undefined
                    ? Number(item.rate).toFixed(2)
                    : "N/A"}
                </td>
                <td className="col-3">
                  {item?.total !== undefined
                    ? Number(item.total).toFixed(2)
                    : ""}
                </td>
                <td className="col-3">
                  {item?.sub_total !== undefined
                    ? Number(item.sub_total).toFixed(2)
                    : ""}
                </td>
                <td className="col-3">{item?.formatting ?? ""}</td>
                <td className="col-3">{item?.word_count ?? ""}</td>
                <td className="col-3">{item?.target_language ?? ""}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewTable;
